import React, { Fragment, PureComponent } from 'react';
import { Table } from 'reactstrap';
import FormatNumber from '../FormatNumber';
import { Spacer } from '../Shimmer';
import {
  boolToString,
  changeTypeLabel,
  MODULE_ADDED,
  MODULE_DELETED,
  MODULE_UPDATED,
} from '../utils';

export default class WoodworkTable extends PureComponent {
  // static defaultProps = {
  //   versions: {},
  //   room: {},
  // };

  // eslint-disable-next-line class-methods-use-this
  generateWoodworkRows(woodwork, priceObj, firstRow, otherRows, rowLength) {
    return [
      <tr key={woodwork.uid} className={rowLength === 1 ? 'module_end' : null}>
        <td className="vlm" rowSpan={rowLength}>
          <span key="updated" className="neutral">
            Updated
          </span>
        </td>
        <td key="woodwork" className="vlm" rowSpan={rowLength}>
          Non-Standard Item
        </td>
        <td
          key={woodwork.productName || woodwork.name}
          className="vlm"
          rowSpan={rowLength}
        >
          {woodwork.productName || woodwork.name}
        </td>
        <td key={priceObj.difference} className="vlm" rowSpan={rowLength}>
          <FormatNumber number={priceObj.difference} />
        </td>
        {firstRow}
      </tr>,
      otherRows.map((otherRow, index) => (
        <tr
          key={`${woodwork.uid}-row-${index}`} // eslint-disable-line react/no-array-index-key
          className={
            rowLength > 1 && rowLength - 2 === index ? 'module_end' : null
          }
        >
          {otherRow}
        </tr>
      )),
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  generateOtherRows(other, priceObj, firstRow, otherRows, rowLength) {
    return [
      <tr key={other.uid} className={rowLength === 1 ? 'module_end' : null}>
        <td className="vlm" rowSpan={rowLength}>
          <span className="neutral">Updated</span>
        </td>
        <td className="vlm" rowSpan={rowLength}>
          Custom Item
        </td>
        <td className="vlm" rowSpan={rowLength}>
          {other.name || other.name}
        </td>
        <td className="vlm" rowSpan={rowLength}>
          <FormatNumber number={priceObj.difference} />
        </td>
        {firstRow}
      </tr>,
      otherRows.map((otherRow, index) => (
        <tr
          key={`${other.uid}-row-${index}`} // eslint-disable-line react/no-array-index-key
          className={
            rowLength > 1 && rowLength - 2 === index ? 'module_end' : null
          }
        >
          {otherRow}
        </tr>
      )),
    ];
  }

  generateOtherNestedTemplate(other) {
    const { diff: otherDiff, ...newOther } = other;
    const priceDifference = otherDiff.filter(md => md.type === 'AMOUNT');
    let priceObj;
    if (priceDifference[0]) {
      priceObj = {
        oldAmount: priceDifference[0].oldValue,
        newAmount: priceDifference[0].newValue,
        difference: priceDifference[0].newValue - priceDifference[0].oldValue,
      };
    } else {
      priceObj = {
        oldAmount: 0,
        newAmount: 0,
        difference: 0,
      };
    }

    const changeMap = otherDiff.map(md => (
      <Fragment>
        <td className="vlm">{changeTypeLabel[md.type]}</td>
        <td className="vlm">
          {md.type === 'AMOUNT' ? Math.round(md.oldValue) : md.oldValue}
        </td>
        <td className="vlm">
          {md.type === 'AMOUNT' ? Math.round(md.newValue) : md.newValue}
        </td>
      </Fragment>
    ));

    const changeLength = changeMap.length;
    const [firstRow, ...otherRows] = changeMap;

    const rowTemplate = this.generateOtherRows(
      newOther,
      priceObj,
      firstRow,
      otherRows,
      changeLength,
    );

    return rowTemplate;
  }

  generateWoodworkNestedTemplate(woodwork) {
    const { diff: woodworkDifference, ...newWoodwork } = woodwork;
    const priceDifference = woodworkDifference.filter(
      md => md.type === 'AMOUNT',
    );
    let priceObj;
    if (priceDifference[0]) {
      priceObj = {
        oldAmount: priceDifference[0].oldValue,
        newAmount: priceDifference[0].newValue,
        difference: priceDifference[0].newValue - priceDifference[0].oldValue,
      };
    } else {
      priceObj = {
        oldAmount: 0,
        newAmount: 0,
        difference: 0,
      };
    }

    const changeMap = woodworkDifference.map((md) => {
      let unitLabel = '';
      if (md.type === 'QUANTITY') {
        const {
          meta: { unit },
        } = md;

        if (unit) {
          unitLabel = unit.replace(/^\w/, c => c.toUpperCase());
        }
      }
      return (
        <Fragment>
          <td className="vlm">{unitLabel || changeTypeLabel[md.type]}</td>
          <td className="vlm">
            {md.type === 'AMOUNT' ? Math.round(md.oldValue) : md.oldValue}
          </td>
          <td className="vlm">
            {md.type === 'AMOUNT' ? Math.round(md.newValue) : md.newValue}
          </td>
        </Fragment>
      );
    });

    const changeLength = changeMap.length;
    const [firstRow, ...otherRows] = changeMap;

    const rowTemplate = this.generateWoodworkRows(
      newWoodwork,
      priceObj,
      firstRow,
      otherRows,
      changeLength,
    );

    return rowTemplate;
  }

  generateWoodworkRowsForTable(woodworks) {
    const tableRows = [];

    woodworks.forEach((woodwork) => {
      const { uid } = woodwork;
      if (woodwork.changeType === 'WOODWORK_UPDATED') {
        tableRows.push(this.generateWoodworkNestedTemplate(woodwork));
      }

      if (woodwork.changeType === 'OTHER_WOODWORK_UPDATED') {
        tableRows.push(this.generateOtherNestedTemplate(woodwork));
      }

      if (
        ['WOODWORK_ADDED', 'WOODWORK_DELETED'].indexOf(woodwork.changeType) > -1
      ) {
        tableRows.push(
          <tr key={uid}>
            <td className="vlm">
              {woodwork.changeType === 'WOODWORK_ADDED' ? (
                <span className="positive">Added</span>
              ) : (
                <span className="negative">Deleted</span>
              )}
            </td>
            <td className="vlm">Non-Standard Item</td>
            <td className="vlm">{woodwork.productName}</td>
            <td className="vlm">
              <FormatNumber
                number={
                  woodwork.changeType === 'WOODWORK_ADDED'
                    ? woodwork.price + woodwork.tax
                    : -(woodwork.price + woodwork.tax)
                }
              />
            </td>
            <td />
            <td />
            <td />
          </tr>,
        );
      }

      if (
        ['OTHER_WOODWORK_ADDED', 'OTHER_WOODWORK_DELETED'].indexOf(
          woodwork.changeType,
        ) > -1
      ) {
        tableRows.push(
          <tr key={uid}>
            <td className="vlm">
              {woodwork.changeType === 'OTHER_WOODWORK_ADDED' ? (
                <span className="positive">Added</span>
              ) : (
                <span className="negative">Deleted</span>
              )}
            </td>
            <td className="vlm">Other</td>
            <td className="vlm">{woodwork.name}</td>
            <td className="vlm">
              <FormatNumber
                number={
                  woodwork.changeType === 'OTHER_WOODWORK_ADDED'
                    ? woodwork.price
                    : -woodwork.price
                }
              />
            </td>
            <td />
            <td />
            <td />
          </tr>,
        );
      }
    });
    return tableRows;
  }

  // eslint-disable-next-line class-methods-use-this
  generateModuleRows(moduleItem, priceObj, firstRow, otherRows, rowLength) {
    return [
      <tr
        key={moduleItem.uid}
        className={rowLength === 1 ? 'module_end' : null}
      >
        <td className="vlm" rowSpan={rowLength}>
          <span className="neutral">Updated</span>
        </td>
        <td className="vlm" rowSpan={rowLength}>
          Modular Item
        </td>
        <td className="vlm" rowSpan={rowLength}>
          {moduleItem.module}
        </td>
        <td className="vlm" rowSpan={rowLength}>
          <FormatNumber number={priceObj.difference} />
        </td>
        {firstRow}
      </tr>,
      otherRows.map((otherRow, index) => (
        <tr
          key={`${moduleItem.uid}-row-${index}`} // eslint-disable-line react/no-array-index-key
          className={
            rowLength > 1 && rowLength - 2 === index ? 'module_end' : null
          }
        >
          {otherRow}
        </tr>
      )),
    ];
  }

  generateModuleNestedTemplate(moduleItem) {
    const { diff: moduleDifference, ...newModule } = moduleItem;
    const priceDifference = moduleDifference.filter(md => md.type === 'AMOUNT');
    let priceObj;
    if (priceDifference[0]) {
      priceObj = {
        oldAmount: priceDifference[0].oldValue,
        newAmount: priceDifference[0].newValue,
        difference: priceDifference[0].newValue - priceDifference[0].oldValue,
      };
    } else {
      priceObj = {
        oldAmount: 0,
        newAmount: 0,
        difference: 0,
      };
    }

    const changeMap = moduleDifference.map((md) => {
      if (
        [
          'ACCESSORY_DELETED',
          'ACCESSORY_ADDED',
          'ACCESSORY_QTY_UPDATED',
        ].indexOf(md.type) > -1
      ) {
        // TODO
        const {
          oldValue,
          newValue,
          meta: { name, qty },
        } = md;

        if (md.type === 'ACCESSORY_ADDED') {
          return (
            <Fragment>
              <td className="vlm">{changeTypeLabel[md.type]}</td>
              <td />
              <td className="vlm">{`${name} (${qty})`}</td>
            </Fragment>
          );
        }

        if (md.type === 'ACCESSORY_DELETED') {
          return (
            <Fragment>
              <td className="vlm">{changeTypeLabel[md.type]}</td>
              <td className="vlm">{`${name} (${qty})`}</td>
              <td />
            </Fragment>
          );
        }

        if (md.type === 'ACCESSORY_QTY_UPDATED') {
          return (
            <Fragment>
              <td className="vlm">{changeTypeLabel[md.type]}</td>
              <td className="vlm">{`${name} (${oldValue})`}</td>
              <td className="vlm">{`${name} (${newValue})`}</td>
            </Fragment>
          );
        }
      }

      if (md.type === 'VISIBLE_SIDE_CHANGE') {
        return (
          <Fragment>
            <td className="vlm">{changeTypeLabel[md.type]}</td>
            <td className="vlm">{md.oldValue}</td>
            <td className="vlm">{md.newValue}</td>
          </Fragment>
        );
      }
      return (
        <Fragment>
          <td className="vlm">{changeTypeLabel[md.type]}</td>
          <td className="vlm">{boolToString(md.oldValue)}</td>
          <td className="vlm">{boolToString(md.newValue)}</td>
        </Fragment>
      );
    });
    const changeLength = changeMap.length;
    const [firstRow, ...otherRows] = changeMap;

    const rowTemplate = this.generateModuleRows(
      newModule,
      priceObj,
      firstRow,
      otherRows,
      changeLength,
    );

    return rowTemplate;
  }

  generateModuleRowsForTable(modules) {
    const tableRows = [];
    Object.keys(modules).forEach((moduleId) => {
      if (
        [MODULE_ADDED, MODULE_DELETED].indexOf(modules[moduleId].changeType)
        > -1
      ) {
        tableRows.push(
          <tr key={moduleId}>
            <td className="vlm">
              {modules[moduleId].changeType === 'MODULE_ADDED' ? (
                <span className="positive">Added</span>
              ) : (
                <span className="negative">Deleted</span>
              )}
            </td>
            <td className="vlm">Modular Item</td>
            <td className="vlm">{modules[moduleId].module}</td>
            <td className="vlm">
              <FormatNumber
                number={
                  modules[moduleId].changeType === 'MODULE_ADDED'
                    ? modules[moduleId].price + modules[moduleId].tax
                    : -1 * (modules[moduleId].price + modules[moduleId].tax)
                }
              />
            </td>
            <td />
            <td />
            <td />
          </tr>,
        );
      }

      if (modules[moduleId].changeType === MODULE_UPDATED) {
        tableRows.push(this.generateModuleNestedTemplate(modules[moduleId]));
      }
    });
    return tableRows;
  }

  render() {
    const { versions, room } = this.props;

    return (
      <Fragment>
        {((room.modules
          && room.modules.diffMap
          && Object.keys(room.modules.diffMap).length > 0)
          || (room.woodWorks && room.woodWorks.length > 0)) && (
          <Fragment>
            <h3>Woodworks</h3>
            <Spacer size={5} />
            <Table>
              <thead>
                <tr>
                  <th width="10%" scope="col">
                    Action
                  </th>
                  <th width="10%" scope="col">
                    Category
                  </th>
                  <th width="30%" scope="col">
                    Name
                  </th>
                  <th width="10%" scope="col">
                    Price diff
                  </th>
                  <th width="10%">Change</th>
                  <th width="15%">
Old Value (
                    {`v${versions.versionOld}`}
)
                  </th>
                  <th width="15%">
                    New Value (
                    {`v${versions.versionCurrent}`}
)
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.generateModuleRowsForTable(room.modules.diffMap)}
                {this.generateWoodworkRowsForTable(room.woodWorks)}
              </tbody>
            </Table>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

// WoodworkTable.propTypes = {
//   versions: PropTypes.object,
//   room: PropTypes.object,
// };



// WEBPACK FOOTER //
// ./src/components/ComparisionTable/Woodwork.js